"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypeSuffixFromConfig = getTypeSuffixFromConfig;
exports["default"] = void 0;

function getTypeSuffixFromConfig(config) {
  var apiPath = config.apiPath,
      _config$method = config.method,
      method = _config$method === void 0 ? 'GET' : _config$method,
      stateKey = config.stateKey,
      tag = config.tag,
      url = config.url;
  return "".concat(method, "_").concat(stateKey || apiPath || url).concat(tag ? "_".concat(tag) : '').toUpperCase();
}

var _default = getTypeSuffixFromConfig;
exports["default"] = _default;